import React from 'react';
import classNames from 'classnames';
import { ArrowIcon } from './components';
import Icon from '../../icon';
import Paragraph from '../../paragraph';
import { Popover, PopoverTrigger, PopoverContent } from '../../popover';
import animatedIcons from './constants/animated-icons';
import BlinkingIcon from '../../blinking-icon';

const CtaTextWithArrow = ({ text = undefined, promoText = undefined, isCompact = false }) => {
  const ctaClassNames = classNames('ws-ui-cta-text', {
    'ws-ui-cta-text--compact': isCompact,
  });

  return (
    <div className={ctaClassNames}>
      {!isCompact && text && <ArrowIcon />}
      <div className="ws-ui-cta-text__text">
        <Paragraph size="large" appearance="accent">
          <span
            // eslint-disable-next-line yola/react/no-danger
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </Paragraph>
        {!isCompact && promoText && (
          <div className="ws-ui-cta-text__promo-popover">
            <Popover
              placement="right-center"
              description={
                <span
                  // eslint-disable-next-line yola/react/no-danger
                  dangerouslySetInnerHTML={{ __html: promoText }}
                />
              }
            >
              <PopoverTrigger>
                <span className="ws-ui-cta-text__icon-container">
                  <Icon glyph="info" type="accent" size="16" />
                </span>
              </PopoverTrigger>
              <PopoverContent />
            </Popover>
          </div>
        )}
      </div>
      {isCompact && promoText && (
        <Paragraph size="small">
          <span
            // eslint-disable-next-line yola/react/no-danger
            dangerouslySetInnerHTML={{ __html: promoText }}
          />
        </Paragraph>
      )}
      {animatedIcons.map(({ key, ...restProps }) => (
        <BlinkingIcon key={key} {...restProps} />
      ))}
    </div>
  );
};

export default CtaTextWithArrow;
